<!--日记详情-->
<template>
  <div style="background:#EFEFEF;padding-bottom: 50px;height:100%">
    <!--pages/index/food/foodDetail/foodDetail.wxml-->
    <div class="activity-top-box">
      <div class="activity-title">{{row.title}}</div>
      <div class="detail-header" v-if="row.style>2">
        <div class="user-face">
          <!-- <img :src="userInfo.face" /> -->
          <img :src="row.user_face" alt srcset />
        </div>
        <div class="user-info">
          <div class="user-names">{{row.user_name}}</div>
          <div class="look-info">{{row.create_time_ago }}</div>
        </div>
        <div class="bottom-right" @click="getShare">分享</div>
      </div>
       <div class="activity-desc" v-html="row.content"></div>

      <!--<div class="activity-desc">{{row.content}}</div>-->

      <div class="active-item-pics" v-if="row.style=='1'&& row.pics.length>0">
					<img :src="row.pics[0].url" alt="">
			</div>

      <div class="video-box" v-for="(item,i) in row.pics " v-if="row.style=='2'">
								<img class="video-img" :src="item.url" alt="">
								<img class="on-play" src="../../../assets/images/activity/icon-video-play@2x.png" alt="" srcset="">
			</div>

      <div class="video-box" style="width:60%;margin-left:40px;position: relative" v-for="(item,i) in row.pics " v-if="row.style=='3'">
        <img style="width:100%" :src="item.url" alt />
        <img class="on-play" src="../../../assets/images/activity/icon-video-play@2x.png" alt srcset />
      </div>

      <div :class="'activity-imgs-'+row.style" v-if="row.style=='4'" :style="(row.pics.length)%3==0 ? 'justify-content:space-between':''">
        <div v-for="(item,i) in row.pics" :style="(row.pics.length)%3==0 ? '':'margin-right:0.1rem'" >
        <img  :src="item.url" alt style="width:2.3rem;height:2.3rem;object-fit: cover;" @click="previewImages(i)" />

        </div>
      </div>

      <div :class="'activity-imgs-'+row.style" v-if="row.style=='5'" >
        <div style="width:4rem;height:4rem">
        <img  :src="row.pics[0].url" v-if="row.pics.length>0" alt style="width:4rem;height:4rem;object-fit: cover;" @click="previewImages(0)" />
        </div>

      </div>

      <div class="activity-detail-bottom">
        <!--<div class="activity-place-box">-->
          <!--<img src="../../../assets/images/activity/Shape@2x.png" alt />-->
          <!--<div class="activity-place">南京新街口</div>-->
        <!--</div>-->
        <div class="release-time">{{row.create_time_ago}}</div>
      </div>
      <div class="zan-box">
        <span class="zan-num">{{row.zan_list.length}}赞</span>
        <img
          class="user-zan-face"
          v-for="(item,i) in row.zan_list"
          :key="i"
          :src="item.user_face"
          alt
        />
      </div>
      <!-- <div class="interactive-box">
			<div class="interactive-item">
				<img src="../../../assets/images/activity/icon-toupiao@2x.png" alt="">
				<div class="interactive-info">
					<p class="interactive-info-title">评选最佳观众投票</p>
					<p class="interactive-info-desc">啦啦操总决赛评选最佳观众有机会获取大奖哦~</p>
				</div>
				<div class="interactive-solid"></div>
				<div style="display: flex;justify-content:center;align-items: center;">
					<div class="interactive-btn">
						立即参与
					</div>
				</div>
			</div>
			<div class="interactive-item">
				<img src="../../../assets/images/activity/icon-zhibo@2x.png" alt="">
				<div class="interactive-info">
					<p class="interactive-info-title">总决赛直播进行中</p>
					<p class="interactive-info-desc">点击这里进入专属直播通道~~</p>
				</div>
				<div class="interactive-solid"></div>
				<div style="display: flex;justify-content:center;align-items: center;">
					<div class="interactive-btn">
						立即参与
					</div>
				</div>
			</div>
      </div>-->
    </div>
    <div class="comments-box">
      <div class="comments-box-title">评论</div>
      <div class="comments-list-box" v-if="row.comment_list.length>0">
        <div class="comments-list" v-for="(item,i) in  row.comment_list" :key="i" @click="onToUserComment(item)" @touchstart="showCommentDeleteButton(item,i)"
                @touchend="emptyTime">
          <div>
            <div class="user-face">
              <img :src="item.user_face" />
              <!-- <img src="../../../assets/images/activity/pic-logo1@2x.png" alt srcset /> -->
            </div>
            <div class="user-info">
              <div class="user-names">{{item.user_name}}</div>
              <div class="look-info">{{item.create_time_ago }}</div>
            </div>
          </div>
          <div class="comments-content" v-if="item.to_user_name==null">{{ item.content }}</div>
          <div class="comments-content" v-else>
            <span style="color:#ccc">
              回复
              <span style="color:#000">{{ item.to_user_name }}:</span>
            </span>
            {{ item.content }}
          </div>
        </div>
      </div>
    </div>

    <div class="send-comments">
      <van-field
        v-model="message"
        maxlength="50"
        :placeholder="commentsPlaceholder"
        show-word-limit
      />
      <div class="zan-btn">
        <img @click="onAddZan" v-if="!row.is_zan" src="../../../assets/images/activity/icon-active-de0.png" alt />
        <img @click="onRemoveZan" v-else src="../../../assets/images/activity/icon-active-de1.png" alt />

      </div>
    </div>
    <van-action-sheet
  v-model="sheetCommentShow"
  :actions="sheetCommentActions"
  cancel-text="取消"
  close-on-click-action
  @cancel="onSheetCancel"
  @select="onSelect"
/>
    <van-image-preview v-model="show" :images="images" :start-position="imagesIndex" @change="onImagesChange">
      <!--<template v-slot:index>第{{ imagesIndex+1 }}页</template>-->
      <template v-slot:cover>
        <div style="    position: fixed;
    left: 0px;
    right: 0px;
    margin: auto;
    bottom: 10px;
    text-align: center;
    color: #fff;
">
          <van-button color="#fb8100" v-if="row.photo_service==1" @click="onDownloadPic" style="margin: 0 auto" plain type="primary">下载图片</van-button>
        </div>
      </template>
    </van-image-preview>


    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />

  </div>
</template>
<style scoped>
/* pages/index/food/foodDetail/foodDetail.wxss */
.video-box .video-img{margin-top: 10px;width: 100%;;}
.active-item-pics{
  padding: 0 10px;
}
.active-item-pics img{
  width: 100%;
}
.activity-imgs {
  display: flex;
  flex-wrap: wrap;
  /* width: 710rpx; */
  margin: 10px auto;
  justify-content: space-between;
  padding:0 10px;
}
.activity-imgs-4{
  display: flex;
  flex-wrap: wrap;
  /* width: 710rpx; */
  margin: 10px auto;
  /* justify-content: space-between; */
  padding:0 10px;
}
.activity-imgs-4 div{
  margin-bottom: 0.1rem;
  width:2.3rem;height:2.3rem
}
.activity-imgs-4 img{
  /* margin-right: 0.1rem; */
   width:2.3rem;height:2.3rem
}
.activity-imgs-5{
  display: flex;
  flex-wrap: wrap;
  /* width: 710rpx; */
  margin: 10px auto;
  /* justify-content: space-between; */
  padding:0 10px;
}

.activity-imgs img {
  width: 30%;
  margin-bottom: 5px;
}
.video-box {
  position: relative;
  padding: 0 10px;
}
.video-box .on-play {
  width: 1rem;
  height: 1rem;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
}
.zan-btn {
  width: 17px;
  height: 17px;
  margin-left: 13.5px;
  margin-right: 10px;
}
.zan-btn img {
  width: 17px;
  height: 17px;
}
.send-comments >>> .van-cell {
  margin-left: 10px;
  padding: 5px 8px;
  background: #eeeeee;
  border-radius: 5px;
}
.send-comments >>> .van-field__control {
  padding-right: 40px;
}
.send-comments >>> .van-field__word-limit {
  position: absolute;
  top: 0;
  right: 0;
}
.send-comments {
  width: 100%;
  height: 1rem;
  border-top: 1px solid #f5f5f5;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.12);
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.comments-content {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 20px;
  margin-left: 32px;
}
.comments-list-box {
  width: 6.7rem;
  border-radius: 10px;
  background: #fff;
  justify-content: space-between;
  margin-bottom: 14.5px;
  padding: 10px;
}
.comments-box {
  width: 7.1rem;

  margin: 10px auto;
}
.comments-box-title {
  height: 26px;
  font-size: 19px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 26px;
  margin: 8px 0;
}

.interactive-box {
  width: 7.1rem;
  margin: 20px auto;
  margin-bottom: 10px;
}
.interactive-item {
  width: 6.7rem;
  height: 1.1rem;
  border-radius: 10px;
  background: #f3f3f3;
  display: flex;
  padding: 10px;
  justify-content: space-between;
  margin-bottom: 14.5px;
}
.interactive-item img {
  width: 40px;
  height: 40px;
  margin-right: 0.18rem;
}
.interactive-solid {
  width: 1px;
  height: 100%;
  background: rgba(0, 0, 0, 0.08);
  margin: 0 0.16rem;
}
.interactive-info {
  flex: 1;
}
.interactive-btn {
  width: 1.5rem;
  height: 0.5rem;
  background: linear-gradient(
    90deg,
    rgba(254, 200, 53, 1) 0%,
    rgba(255, 173, 25, 1) 100%
  );
  border-radius: 5px;
  text-align: center;
  line-height: 0.5rem;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.85);
}
.interactive-info-title {
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 20px;
}
.interactive-info-desc {
  height: 33px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 16.5px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.zan-box {
  display: flex;
  flex-direction: row-reverse;
  padding: 0 10px;
}
.user-zan-face {
  width: 22px;
  height: 22px;
  border-radius: 22px;
  margin-right: 4px;
}
.zan-num {
  padding: 1px 5px;
  background: rgba(231, 231, 231, 1);
  border-radius: 22px;
  font-size: 11px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
}
.activity-top-box {
  padding-bottom: 10px;
  border-radius: 0 0 10px 10px;
  background: #fff;
}
.activity-detail-bottom {
  padding-left: 10px;
}
.activity-place-box {
  display: flex;
  align-items: center;
}
.release-time {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(190, 190, 190, 1);
  margin-left: 5px;
}
.activity-place-box img {
  width: 15px;
  height: 20px;
}
.activity-place {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(190, 190, 190, 1);
  margin-left: 5px;
}
.comment-box {
  background: #fff;
}
.comment-desc {
  padding: 0 0.3rem;
  margin-bottom: 0.1rem;
}
.comment-item-list {
  display: flex;
  overflow-x: scroll;
}
.item-desc {
  margin-right: 0.2rem;
}
.item-desc img {
  height: 2rem;
}
.comment-img-list {
  padding: 0 0.2rem;
  overflow-x: scroll;
}

.comment-img {
  display: block;
  height: 80px;
  width: 100px;
  margin-right: 0.1rem;
  float: left;
}
.comment-header {
  padding: 10px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
}
.comment-num {
  text-align: center;
}
.comment {
  padding: 10px 10px;
  display: flex;
  align-items: center;
  background: #fff;
  margin-top: 10px;
}
.comment-btn {
  height: 28px;
  line-height: 28px;
  text-align: center;
  color: #ccc;
  border: 1px solid #cccccc;
  border-radius: 10px;
  width: 60%;
}
.comment-user-face {
  height: 32px;
  width: 32px;
  border-radius: 50%;
  overflow: hidden;
  float: left;
  background: #ccc;
}
.comment-user-face img {
  width: 32px;
  height: 32px;
}
.activity-title {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  padding: 10px 10px;
  background: #fff;
}
.comments-list {
  background: #fff;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}
.detail-header {
  height: 40px;
  padding: 10px 10px;
  background: #fff;
}
.user-face {
  height: 32px;
  width: 32px;
  border-radius: 50%;
  overflow: hidden;
  float: left;
}
.user-face img {
  height: 32px;
  width: 32px;
}
.user-info {
  margin-left: 5px;
  float: left;
}
.user-info view {
  height: 50px;
  line-height: 50px;
}
.user-names {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.look-info {
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(190, 190, 190, 1);
  line-height: 17px;
}
.bottom-right {
  float: right;
  height: 50px;
  background: url(https://static.dierqudao.com/images/mishijia/icon-mishijia-bshare.png)
    no-repeat left center;
  padding: 0 25px;
  background-size: 16px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 50px;
}
.activity-desc {
  padding: 10px 10px;
  background: #fff;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  overflow: hidden;
}
</style>

<script>
import Vue from "vue";
import { ImagePreview, Field,Toast } from "vant";
import { getTimeFormat } from "../../../utils/date";
import LoginDialog from '@/components/LoginDialog.vue';
Vue.use(ImagePreview).use(Field).use(Toast);
export default {
  name: "ActivityDetail",
  components: {
    ImagePreview,LoginDialog
  },
  data: function() {
    return {
      message: "",
      commentsPlaceholder: "",
      activityId: 0,
      row: {
        zan_list: [],
        comment_list:[]
      },
      userInfo: {},
      recomGoodsLsit: [],
      materialList: [],
      images: [],
      imagesIndex: 0,
      show: false,
      loginShow: false,
      shareShow: false,
      sheetCommentShow:false,
       Loop:null,
      sheetCommentActions: [{ name: '删除评论' }],
      activityData: {},
      shareData: {},
      to_comment_id:0,
      commentIndex:0
    };
  },

  mounted() {
    let that=this
    document.title = "详情";
    that.activityId = this.$route.query.id || 254;
    that.fetch();

    document.addEventListener("keydown", function(event) {
      // console.log(event.key)
      if(event.key=='Enter'){
        that.onCommentSend()
      }
    });
  },
  destroyed() {},
  methods: {
    showCommentDeleteButton(item,i){
      console.log(item,i)
      clearTimeout(this.Loop); //再次清空定时器，防止重复注册定时器
      this.Loop = setTimeout(
        function() {
          // console.log(e)
          if(item.is_admin){
            console.log("删除")
            this.commentIndex=i
            this.sheetCommentShow=true
            // this.$emit("deleteComment",i)
          }
        }.bind(this),
        800
      );
    },

    emptyTime() {
      clearTimeout(this.Loop); //清空定时器，防止重复注册定时器
    },
    onSelect(action,index){
      console.log(action,index)
      switch (action.name){
        case '删除评论':
           this.CommentDetele()
        break;
      }
    },
    CommentDetele(){
      //删除评论
      let that=this
      let id=this.row.comment_list[this.commentIndex].id
      console.log(id,this.commentIndex)
      that.$api.get(
        "/api/activity/commentDelete",
        {id:id},
        res => {
          this.row.comment_list.splice(that.commentIndex,1)
          Toast('删除成功!');
          this.commentsPlaceholder="已有" + this.row.comment_list.length + "条回复,参与互动 !";
        },
        res => {
          Toast(res.msg);
        }
      );
    },
    onSheetCancel() {
      // Toast('取消');
    },
    onImageView(i){
      let pics=[]
      this.row.pics.map((item)=>{
        pics.push(item.url)
      })
      ImagePreview({
        images:pics,
        startPosition: i})
    },
    onImagesChange(index){
      this.imagesIndex = index;
    },
    //查看大图
    previewImages(i) {
      let pics=[]
      this.row.pics.map((item)=>{
        pics.push(item.url)
      });

      this.images = pics;
      this.imagesIndex = i;
      /*
      console.log(i);
      this.startPosition = parseInt(index) + 1;
      this.images = [];
      this.materialList[i].pics.map((item, i) => {
        this.images.push(item.url);
      });*/
      this.show = true;
    },
    onToUserComment(item){
      console.log(item)
      this.commentsPlaceholder='@'+item.user_name
      this.to_comment_id=item.id
    },

    onCommentSend(){
      let that=this
      // console.log('发送评论',this.item,this.message)
      that.$api.get(
        "/api/activity/commentAdd",
        {
          topic_id: this.row.id,
          content:this.message,
          to_comment_id:this.to_comment_id
        },
        res => {
         console.log(res)
         this.row.comment_list.push(res.data)
         this.message=''
         this.to_comment_id=0,
         this.commentsPlaceholder="已有" + this.row.comment_list.length + "条回复,参与互动 !";
        },
        res => {
          Toast(res.msg);
        }
      );

    },
    getShare() {
      let that = this;
      // 判断是否登陆
      that.$api.get(
        "/api/user/userPage",
        {},
        res => {
          this.shareShow = true;
        },
        res => {
          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                {
                  name: "login",
                  query: {}
                },
                "replace"
              );
              return false;
            }
            that.loginShow = true;
          } else {
            Toast(res.msg);
          }
        }
      );
      this.activityData = this.row;
      this.shareData = this.row.share;
      console.log(goods);
    },
    shareCancel() {
      console.log("-------取消分享-------");
      this.shareShow = false;
    },
    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      let that = this;
      that.loginShow = false;
      this.fetch();
      // that.showSkuPicker = true
    },
    loginCancel() {
      console.log("-------取消登录--------");
      this.fetch();
      this.loginShow = false;
    },
    fetch() {
      let that = this;
      this.$api.get(
        "/api/activity/topicdetail",
        { id: this.activityId },
        res => {
          that.row = res.data;
          that.recomGoodsLsit = res.data.goods_list;
          that.userInfo = res.data.user_info;
          that.materialList = res.data.material_list;
          that.commentsPlaceholder =
            "已有" + res.data.comment_list.length + "条回复,参与互动 !";
          console.log(that.row);
        }
      );
    },
    onDownloadPic(){
      let that = this;
      that.$api.post(
              "/api/activity/checkpicdownload",
              { topic_id: this.activityId,
                activity_id:this.row.activity_id,
                index:this.imagesIndex
              },
              res => {
                var fileExtension = that.images[that.imagesIndex].split('.').pop().toLowerCase();
                console.log({
                  name: 'downloadPic',
                  query: {
                    'filename' : that.row.id+'-'+that.imagesIndex+'.'+fileExtension,
                        'url' : that.images[that.imagesIndex]
              }
              });
                appEvent({
                  name: 'downloadPic',
                  query: {
                    'filename' : that.row.id+'-'+that.imagesIndex+'.'+fileExtension,
                    'url' : that.images[that.imagesIndex],
                  }
                });

              },
              res => {
                if (res.code == 401 || res.code == 402) {
                  if (window.isApp()) {
                    rbLink(
                            {
                              name: "login",
                              query: {}
                            },
                            "replace"
                    );
                    return false;
                  }
                  that.loginShow = true
                } else if(res.code == 505){
                  rbLink(
                          {
                            name: "ActivityPicOrderForm",
                            query:
                            { topic_id: that.activityId,
                              activity_id:that.row.activity_id,
                              index:that.imagesIndex
                            }
                          }
                  );
                  return false;
                } else {
                  Toast(res.msg);
                }
              }
      );
    },
    onAddZan() {
      let that = this;
      that.$api.post(
        "/api/activity/zanadd",
        { topic_id: this.activityId },
        res => {
          // this.fetch();
          this.row.zan_list.push(res.data)
          this.row.is_zan=true
        },
        res => {
          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                {
                  name: "login",
                  query: {}
                },
                "replace"
              );
              return false;
            }
            that.loginShow = true
            // this.$emit("loginStatus", true);
          } else {
            Toast(res.msg);
          }
        }
      );
    },
    onRemoveZan() {
      let that = this;
      that.$api.post(
        "/api/activity/zanremove",
        { topic_id: this.activityId },
        res => {
          // that.row = res.data;
          this.row.zan_list.map((item,i)=>{
            if(res.data.user_id==item.user_id){
              this.row.zan_list.splice(i,1)
            }
          })
          this.row.is_zan=false
          // this.fetch();
        },
        res => {
          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                {
                  name: "login",
                  query: {}
                },
                "replace"
              );
              return false;
            }
            that.loginShow = true
            // this.$emit("loginStatus", true);
          } else {
            Toast(res.msg);
          }
        }
      );
    },
  },
  filters: {
    getTimeFormat: getTimeFormat
  }
};
</script>


// WEBPACK FOOTER //
// ActivityDetail.vue?1b3185a8